import { TLocale } from "@src/i18n";

const pathLocaleList = ["en", "pt", "vi", "zh", "my", "id", "ne"];

export function getLocalFromPath(prefix: string) {
  const pathArr = location.pathname.split("/");
  const langIdx = pathArr.findIndex((item) => item === prefix);
  const pathLocale = pathArr[langIdx - 1];
  if (!pathLocale || !pathLocaleList.includes(pathLocale)) {
    return;
  }
  return pathLocale as TLocale;
}
